// constants/eventTypes.js
//
// The event types a host can pick, copied from the app's
// src/features/create/components/EventTypeSelector.js — same labels, same
// emoji, same order.
//
// The website had eleven of these ("Birthday, Wedding, Party, Conference,
// Workshop, Meetup, Concert, Festival, Fundraiser, Sports Event, Other")
// against the app's seventy. That is not only a shorter menu: `event_type` is
// what the cover-template library is keyed on, so a host picking "Party" on
// the web got the templates for a type the app never writes, while Mehendi,
// Sangeet, Haldi, Pooja, Diwali and the rest of the list the product is
// actually used for were unreachable.

export const EVENT_TYPES = [
  { label: 'Anniversary', emoji: '💍' },
  { label: 'Annual Function', emoji: '🏫' },
  { label: 'Art Exhibition', emoji: '🖼️' },
  { label: 'Baby Naming Ceremony', emoji: '👶' },
  { label: 'Baby Shower', emoji: '🤰' },
  { label: 'BBQ', emoji: '🔥' },
  { label: 'Beach Party', emoji: '🏖️' },
  { label: 'Birthday Party', emoji: '🎂' },
  { label: 'Book Club Meetup', emoji: '📚' },
  { label: 'Bridal Shower', emoji: '👰' },
  { label: 'Camping', emoji: '🏕️' },
  { label: 'Charity Event', emoji: '❤️' },
  { label: 'Christmas Party', emoji: '🎄' },
  { label: 'Cocktail Party', emoji: '🍸' },
  { label: 'Community Gathering', emoji: '🏘️' },
  { label: 'Conference', emoji: '🎤' },
  { label: 'Concert', emoji: '🎶' },
  { label: 'Cultural Event', emoji: '🎭' },
  { label: 'Diwali', emoji: '🪔' },
  { label: 'Dinner Party', emoji: '🍽️' },
  { label: 'Eid', emoji: '🌙' },
  { label: 'Engagement Party', emoji: '💍' },
  { label: 'Farewell Party', emoji: '👋' },
  { label: 'Festival', emoji: '🎊' },
  { label: 'Festival Afterparty', emoji: '🎉' },
  { label: 'Freshers Party', emoji: '🎓' },
  { label: 'Fundraiser', emoji: '💖' },
  { label: 'Game Night', emoji: '🎮' },
  { label: 'Graduation', emoji: '🎓' },
  { label: 'Haldi', emoji: '🌼' },
  { label: 'Halloween Party', emoji: '🎃' },
  { label: 'Hiking', emoji: '🥾' },
  { label: 'Holiday Celebration', emoji: '🎈' },
  { label: 'Holi', emoji: '🌈' },
  { label: 'Housewarming', emoji: '🏠' },
  { label: 'Jagraata', emoji: '🕯️' },
  { label: 'Katha', emoji: '📖' },
  { label: 'Karaoke Night', emoji: '🎤' },
  { label: 'Launch Party', emoji: '🚀' },
  { label: 'Meet & Greet', emoji: '🤝' },
  { label: 'Mehendi', emoji: '🌿' },
  { label: 'Movie Night', emoji: '🎬' },
  { label: 'Music Festival', emoji: '🎪' },
  { label: 'Music Night', emoji: '🎧' },
  { label: 'Music Party', emoji: '🎵' },
  { label: 'Networking Event', emoji: '💼' },
  { label: 'New Year Party', emoji: '🎆' },
  { label: 'Office Party', emoji: '🏢' },
  { label: 'Open Mic', emoji: '🎙️' },
  { label: 'Orientation', emoji: '🧭' },
  { label: 'Other', emoji: '✨' },
  { label: 'Paath', emoji: '📿' },
  { label: 'Photo Walk', emoji: '📸' },
  { label: 'Picnic', emoji: '🧺' },
  { label: 'Pool Party', emoji: '🏊' },
  { label: 'Pooja', emoji: '🛕' },
  { label: 'Potluck', emoji: '🍲' },
  { label: 'Reunion', emoji: '🔁' },
  { label: 'Religious Ceremony', emoji: '🛐' },
  { label: 'Road Trip', emoji: '🚗' },
  { label: 'Sangeet', emoji: '🎼' },
  { label: 'Seminar', emoji: '🧑‍🏫' },
  { label: 'Sports Viewing', emoji: '🏀' },
  { label: 'Startup Pitch Event', emoji: '🚀' },
  { label: 'Tea Party', emoji: '🫖' },
  { label: 'Vacation', emoji: '🏝️' },
  { label: 'Vaccination', emoji: '💉' },
  { label: 'Wedding', emoji: '💒' },
  { label: 'Workshop', emoji: '🛠️' },
  { label: 'Wellness Session', emoji: '🧘' },
  { label: 'Yoga Session', emoji: '🧘‍♂️' },
];

/** The emoji for a stored label, or a neutral one for a custom type. */
export const emojiForEventType = (label) =>
  EVENT_TYPES.find((t) => t.label === label)?.emoji ?? '✨';
